module.exports = __webpack_public_path__ + "static/office-inside-narrow-8c90cf6da2a025c3177e62a15b606a46.jpg";